// import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { BehaviorSubject, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedservicesService {
    // tslint:disable-next-line:no-inferrable-types
    constructor(private httpClient: HttpClient) {}
  public headers = new HttpHeaders()
    .set('content-type', 'application/json')
    .set('Access-Control-Allow-Origin', '*');
    private loogedInStatus = JSON.parse(localStorage.getItem('loggedIn')||'false');
    url : string = "https://raw.githubusercontent.com/sagarshirbhate/Country-State-City-Database/master/Contries.json";  

    public shareData = new BehaviorSubject<any>(''); 

    public sharedUserComplaint = new BehaviorSubject<any>('');

    public customerComplaintStatus = new BehaviorSubject<any>('');

    telecast = this.shareData.asObservable();

    telecastcomplaint = this.sharedUserComplaint.asObservable();

    CustomerEmail_isLoggin: any;
    public urlGetPost = 'https://n7xb6zm0t9.execute-api.ap-south-1.amazonaws.com/production';
    //public urlGetPost = 'http://localhost:3500';
    public GetPostURL() {
      return this.urlGetPost;
    }

    public storeDatabwComp(data) {
      this.CustomerEmail_isLoggin = data.customerEmail;
      localStorage.setItem('customerInfo', JSON.stringify(data));
      this.shareData.next(data);
    }

    public CustomercomplaintStatus(data) {
      localStorage.setItem('customerId', JSON.stringify(data));
      this.sharedUserComplaint.next(data);
    }
    public allCountries(): Observable<any> {
      return this.httpClient.get(this.url);
    }

    public getAllCustomerEmail(data) {
      return this.httpClient.post(`${this.urlGetPost}/customer/getallemail`, data);
    }

    public changeCompalintStatus(data) {
      return this.httpClient.post(`${this.urlGetPost}/agent/complaint/updatestatus`, data);
    }

    public customerSubmitComplain(data) {
      return this.httpClient.post(`${this.urlGetPost}/customer/submit/complaint`, data);
    }

    public getAllTheCustomerComplaints(data) {
      return this.httpClient.post(`${this.urlGetPost}/agent/getallcustomer/complaint`, data);
    }

    public getOnlyCustomerComplaints(data) {
      return this.httpClient.post(`${this.urlGetPost}/customer/listcomplaints`, data);
    }

    public FetchAgentComplaints(data) {
      return this.httpClient.post(`${this.urlGetPost}/agent/fetch/complaint`, data);
    }

    public FetchCustomerComplaints(data) {
      return this.httpClient.post(`${this.urlGetPost}/user/fetch/complaint`, data);
    }

    public CustomerLogin(data) {
      return this.httpClient.post(`${this.urlGetPost}/customer/login`, data);
    }

    public AgentLogin(data) {
      return this.httpClient.post(`${this.urlGetPost}/agent/login`, data);
    }

    public CustomerRegistration(data) {
      return this.httpClient.post(`${this.urlGetPost}/customer/registration`, data);
    }

    public AgentRegistration(data) {
      return this.httpClient.post(`${this.urlGetPost}/agent/registration`, data);
    }
}
